import React, { useEffect, useRef, useState, Suspense } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import Block from '../../adapters/helpers/Block';
import { toggleScroll } from '../../adapters/helpers/Utils';
const Icon = dynamic(() => import('../Icon/Icon'));
import { ProductOverlayConstants } from '../../adapters/helpers/Constants';
import { loadScript } from '../../adapters/helpers/Utils';
import { getBuyNowLiteRetailerList } from '../../adapters/model/service/api/buyNowLite';
import Loader from '../../adapters/helpers/Loader';
export default function ProductOverlay(props) {
  var _block$getFieldValue, _block$getFieldValue$, _block$getFieldValue2, _block$getFieldValue3;
  const displayBuyNowLite = (process.env.ACTIVATE_BUY_NOW_LITE || false) === 'TRUE';
  const {
    customEvent,
    onClickCallback,
    states = {
      isOverlayOpen: false
    },
    extraAttributes
  } = props;
  const block = new Block(props);
  const [isOverlayOpen, setIsOverlayOpen] = useState(states.isOverlayOpen);
  const [lastButton, setLastButton] = useState(null);
  const [lastScroll, setLastScroll] = useState(0);
  const [productSku, setProductSku] = useState('');
  const KEYCODE_ESC = 27;
  const anchorId = block.getAnchorId();
  const productOverlayRef = useRef();
  const closeOverlayLabel = (_block$getFieldValue = block.getFieldValue(ProductOverlayConstants.closeOverlayLabel)) == null ? void 0 : (_block$getFieldValue$ = _block$getFieldValue.fields) == null ? void 0 : _block$getFieldValue$.text;
  const buyNowLiteErrorLabel = (_block$getFieldValue2 = block.getFieldValue(ProductOverlayConstants.buyNowLiteErrorLabel)) == null ? void 0 : (_block$getFieldValue3 = _block$getFieldValue2.fields) == null ? void 0 : _block$getFieldValue3.text;
  let classNames = block.getFieldValue(ProductOverlayConstants.classNames) ? block.getFieldValue(ProductOverlayConstants.classNames) : ProductOverlayConstants.empty;
  classNames += `${anchorId}`;
  useEffect(() => {
    var _extraAttributes$enti, _extraAttributes$enti2, _extraAttributes$enti3, _extraAttributes$enti4;
    setLastScroll(window.pageYOffset);
    const productVariants = extraAttributes == null ? void 0 : (_extraAttributes$enti = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti2 = _extraAttributes$enti.productOverview) == null ? void 0 : (_extraAttributes$enti3 = _extraAttributes$enti2.fields) == null ? void 0 : _extraAttributes$enti3.productVariants;
    const series = extraAttributes == null ? void 0 : (_extraAttributes$enti4 = extraAttributes.entity) == null ? void 0 : _extraAttributes$enti4.series;
    let initialSku = '';
    if (extraAttributes) {
      var _productVariants$, _productVariants$$fie, _series$, _series$$fields, _series$$fields$featu, _series$$fields$featu2, _series$$fields$featu3, _series$2, _series$2$fields, _series$2$fields$feat, _series$2$fields$feat2, _series$2$fields$feat3, _series$2$fields$feat4;
      if ((productVariants == null ? void 0 : productVariants.length) > 0 && ((_productVariants$ = productVariants[0]) == null ? void 0 : (_productVariants$$fie = _productVariants$.fields) == null ? void 0 : _productVariants$$fie.sku)) {
        var _extraAttributes$enti5, _extraAttributes$enti6, _extraAttributes$enti7, _extraAttributes$enti8, _extraAttributes$enti9;
        initialSku = extraAttributes == null ? void 0 : (_extraAttributes$enti5 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti6 = _extraAttributes$enti5.productOverview) == null ? void 0 : (_extraAttributes$enti7 = _extraAttributes$enti6.fields) == null ? void 0 : (_extraAttributes$enti8 = _extraAttributes$enti7.productVariants[0]) == null ? void 0 : (_extraAttributes$enti9 = _extraAttributes$enti8.fields) == null ? void 0 : _extraAttributes$enti9.sku;
      } else if ((series == null ? void 0 : series.length) > 0 && ((_series$ = series[0]) == null ? void 0 : (_series$$fields = _series$.fields) == null ? void 0 : (_series$$fields$featu = _series$$fields.featuredProduct) == null ? void 0 : (_series$$fields$featu2 = _series$$fields$featu.fields) == null ? void 0 : (_series$$fields$featu3 = _series$$fields$featu2.productVariants) == null ? void 0 : _series$$fields$featu3.length) > 0 && ((_series$2 = series[0]) == null ? void 0 : (_series$2$fields = _series$2.fields) == null ? void 0 : (_series$2$fields$feat = _series$2$fields.featuredProduct) == null ? void 0 : (_series$2$fields$feat2 = _series$2$fields$feat.fields) == null ? void 0 : (_series$2$fields$feat3 = _series$2$fields$feat2.productVariants[0]) == null ? void 0 : (_series$2$fields$feat4 = _series$2$fields$feat3.fields) == null ? void 0 : _series$2$fields$feat4.sku)) {
        var _extraAttributes$enti10, _extraAttributes$enti11, _extraAttributes$enti12, _extraAttributes$enti13, _extraAttributes$enti14, _extraAttributes$enti15, _extraAttributes$enti16;
        initialSku = extraAttributes == null ? void 0 : (_extraAttributes$enti10 = extraAttributes.entity) == null ? void 0 : (_extraAttributes$enti11 = _extraAttributes$enti10.series[0]) == null ? void 0 : (_extraAttributes$enti12 = _extraAttributes$enti11.fields) == null ? void 0 : (_extraAttributes$enti13 = _extraAttributes$enti12.featuredProduct) == null ? void 0 : (_extraAttributes$enti14 = _extraAttributes$enti13.fields) == null ? void 0 : (_extraAttributes$enti15 = _extraAttributes$enti14.productVariants[0]) == null ? void 0 : (_extraAttributes$enti16 = _extraAttributes$enti15.fields) == null ? void 0 : _extraAttributes$enti16.sku;
      }
    }
    setProductSku(initialSku);
  }, []);
  const onGetBuyNowLiteRetailerListSuccess = (data, sku) => {
    const buyNowLiteContainer = document.querySelector('.buy-now-lite-container');
    for (const item of data) {
      let linkNode = document.createElement('a');
      linkNode.href = item.BuyNowUrl;
      linkNode.target = '_blank';
      linkNode.rel = 'noopener noreferrer';
      linkNode.className = 'buy-now-lite-link event_buy_now_eretailer_exit';
      let imgNode = document.createElement('img');
      imgNode.src = 'data:image/png;base64,' + item.Retailerlogo;
      imgNode.className = 'buy-now-lite-img';
      imgNode.alt = '';
      linkNode.appendChild(imgNode);
      linkNode.setAttribute('data-action-detail', `${sku}_${item == null ? void 0 : item.RetailerName}`);
      buyNowLiteContainer.appendChild(linkNode);
    }
    openBuyNowLiteModal();
  };
  const onGetBuyNowLiteRetailerListFailure = () => {
    // close modal and remove buy now lite retailer images from modal.
    const buyNowLiteContainer = document.querySelector('.buy-now-lite-container');
    let paragraphNode = document.createElement('p');
    paragraphNode.className = 'buy-now-lite-error-message';
    paragraphNode.textContent = buyNowLiteErrorLabel;
    buyNowLiteContainer.appendChild(paragraphNode);
    openBuyNowLiteModal();
  };
  useEffect(() => {
    if (!(customEvent == null ? void 0 : customEvent.event)) {
      return;
    }
    if (customEvent.event instanceof HTMLElement || customEvent.event instanceof Node) {
      var _customEvent$event, _customEvent$event$da, _customEvent$event2, _customEvent$event2$d;
      if (displayBuyNowLite) {
        customEvent.event.disabled = true;
      }
      const sku = (customEvent == null ? void 0 : (_customEvent$event = customEvent.event) == null ? void 0 : (_customEvent$event$da = _customEvent$event.dataset) == null ? void 0 : _customEvent$event$da.sku) ? customEvent.event.dataset.sku : '';
      let resetCountryCode = (customEvent == null ? void 0 : (_customEvent$event2 = customEvent.event) == null ? void 0 : (_customEvent$event2$d = _customEvent$event2.dataset) == null ? void 0 : _customEvent$event2$d.resetCountryCode) ? customEvent.event.dataset.resetCountryCode : false;

      // ACTIVATE_BUY_NOW_LITE is true for japan
      if (process.env.ACTIVATE_BUY_NOW_LITE === ProductOverlayConstants.BUY_NOW_LITE_TRUE) {
        if (sku !== '') {
          // Ajax call to get retailer data.
          getBuyNowLiteRetailerList(sku, onGetBuyNowLiteRetailerListSuccess, onGetBuyNowLiteRetailerListFailure);
        } else {
          // If no sku, close modal and remove buy now lite retailer images from modal.
          const buyNowLiteContainer = document.querySelector('.buy-now-lite-container');
          buyNowLiteContainer.innerHTML = '';
          closeBuyNowLiteModal();
        }
      } else {
        var _window;
        // Price spider buy now case.
        if (sku !== '' && window.PriceSpider === undefined) {
          // script priceSpider with callback
          loadScript(ProductOverlayConstants.priceSpiderSource, error => {
            if (error) {
              console.log(ProductOverlayConstants.priceSpiderConsoleLogMessageError);
            } else {
              // script loaded successfully
              setProductSku(sku);
              setLastButton(customEvent.event);
              setIsOverlayOpen(true);
            }
          });
        } else if (sku !== '') {
          // script already loaded
          setProductSku(sku);
          setLastButton(customEvent.event);
          setIsOverlayOpen(true);
        } else {
          setProductSku('');
          setIsOverlayOpen(false);
        }
        if (resetCountryCode && ((_window = window) == null ? void 0 : _window.PriceSpider)) {
          window.PriceSpider.reset();
        }
      }
    }
  }, [customEvent]);
  useEffect(() => {
    var _window2;
    if (productSku !== '' && ((_window2 = window) == null ? void 0 : _window2.PriceSpider)) {
      window.PriceSpider.rebind();
    }
  }, [productSku]);
  useEffect(() => {
    if (productOverlayRef == null ? void 0 : productOverlayRef.current) {
      toggleOverlay();
      productOverlayRef.current.addEventListener(ProductOverlayConstants.keydown, trapFocusInOverlay);
      return () => {
        var _productOverlayRef$cu;
        productOverlayRef == null ? void 0 : (_productOverlayRef$cu = productOverlayRef.current) == null ? void 0 : _productOverlayRef$cu.removeEventListener(ProductOverlayConstants.keydown, trapFocusInOverlay);
      };
    }
  }, [isOverlayOpen]);
  useEffect(() => {
    const handleScroll = throttle(() => {
      if (!document.body.classList.contains(ProductOverlayConstants.noScroll)) {
        setLastScroll(window.pageYOffset);
      }
    }, 100);
    window.addEventListener(ProductOverlayConstants.scroll, handleScroll);
    return () => {
      window.removeEventListener(ProductOverlayConstants.scroll, handleScroll);
    };
  }, [lastScroll]);
  const closeBuyNowLiteModal = () => {
    setProductSku('');
    setIsOverlayOpen(false);
  };
  const openBuyNowLiteModal = () => {
    if (displayBuyNowLite) {
      customEvent.event.disabled = false;
    }
    setLastButton(customEvent.event);
    setIsOverlayOpen(true);
  };
  const toggleOverlay = () => {
    const productOverlayElem = productOverlayRef.current;
    let ele = document.getElementById('ob-product-subnav-scroll');
    if (isOverlayOpen) {
      if (ele) {
        ele.setAttribute('style', 'z-index:99 !important');
      }
      productOverlayElem.classList.add(ProductOverlayConstants.isActive);
      productOverlayElem.focus();
    } else {
      if (ele) {
        ele.setAttribute('style', 'z-index:999 !important');
      }
      productOverlayElem.classList.remove(ProductOverlayConstants.isActive);
      document.body.style.top = null;
      document.body.style.height = null;
      if (lastButton) {
        lastButton.focus();
      }
    }
    toggleScroll(isOverlayOpen, lastScroll);
  };
  const trapFocusInOverlay = event => {
    if (!isOverlayOpen) {
      return;
    }
    const element = event.currentTarget;
    const focusableElements = element.querySelectorAll(ProductOverlayConstants.querySelectorAll);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    const KEYCODE_TAB = 9;
    const isTabPressed = event.key === ProductOverlayConstants.Tab || event.keyCode === KEYCODE_TAB;
    handleEscapeKeyPress(event);
    if (!isTabPressed) {
      return;
    }
    if (event.shiftKey) /* shift + tab */{
        if (document.activeElement === firstFocusableElement) {
          lastFocusableElement.focus();
          event.preventDefault();
        }
      } else /* tab */{
        if (document.activeElement === lastFocusableElement) {
          firstFocusableElement.focus();
          event.preventDefault();
        }
      }
  };
  const handleBackgroundClick = event => {
    event.stopPropagation();
    if (event.target === document.querySelector('.ob-product-overlay')) {
      setIsOverlayOpen(false);
      if (displayBuyNowLite) {
        // When clicking in background remove buy now lite retailer.
        const buyNowLiteContainer = document.querySelector('.buy-now-lite-container');
        buyNowLiteContainer.innerHTML = '';
      }
    }
  };
  const handleEscapeKeyPress = event => {
    if (event.key === ProductOverlayConstants.Escape || event.keyCode === KEYCODE_ESC) {
      setIsOverlayOpen(false);
    }
  };
  return <Suspense fallback={<Loader />}>
        <div role='presentation' onClick={handleBackgroundClick} onKeyDown={handleEscapeKeyPress} ref={productOverlayRef} className={`ob-product-overlay ${classNames}`}>
            <div className={`ob-product-overlay__wrapper ${displayBuyNowLite ? 'ob-product-overlay__wrapper--buy-now-lite' : ''}`}>
                {isOverlayOpen && <button aria-label={closeOverlayLabel} className={'ob-product-overlay__close-btn'} onClick={event => onClickCallback(event)}>
                        <Icon name={ProductOverlayConstants.close} size={2} />
                    </button>}
                <div id="ob-product-overlay__content">
                    {displayBuyNowLite ? <>
                            <div className="buy-now-lite-container">

                            </div>
                        </> : <>
                            <div className="ps-widget" ps-sku={productSku} data-action-detail={productSku}></div>
                        </>}


                </div>
            </div>
        </div>
        </Suspense>;
}
ProductOverlay.propTypes = {
  customEvent: PropTypes.object,
  onClickCallback: PropTypes.func,
  states: PropTypes.object,
  children: PropTypes.node,
  extraAttributes: PropTypes.object
};